import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { Fixture, FixtureMatchStats, GameScoreValues } from '../models/fixture-models';
import { Player } from '../models/tile-models';

/**
 * Events of the fixtures region: the match list, the squad, the scoring config and the
 * per-fixture prediction the user edits.
 *
 * `savePrediction*` carries the `fixtureId` on every step because saves are debounced
 * and tracked PER FIXTURE — switching matches mid-edit must never let one fixture's
 * outcome (or rollback) land on another.
 */
export const fixturesEvents = eventGroup({
  source: 'Fixtures',
  events: {
    loadFixtures: type<void>(),
    loadFixturesSuccess: type<{ fixtures: Fixture[]; initialIndex: number }>(),
    loadFixturesFailed: type<{ error: string }>(),
    loadPlayers: type<void>(),
    loadPlayersSuccess: type<{ players: Player[] }>(),
    loadPlayersFailed: type<{ error: string }>(),
    loadGameScoreValues: type<void>(),
    loadGameScoreValuesSuccess: type<{ gameScoreValues: GameScoreValues }>(),
    loadGameScoreValuesFailed: type<{ error: string }>(),
    savePrediction: type<{ fixtureId: string; prediction: FixtureMatchStats }>(),
    savePredictionRequestStarted: type<{ fixtureId: string }>(),
    savePredictionSuccess: type<{ fixture: Fixture }>(),
    savePredictionFailed: type<{ fixtureId: string; error: string }>(),
    selectFixture: type<{ index: number }>(),
  },
});
